export default __webpack_public_path__ + "static/media/HomePage.97d6f372.png";